// Shared arrival-window options + a 24h->12h time formatter for all scheduling UIs.
export const ARRIVAL_WINDOWS = [
  "All day",
  "8–10am",
  "10am–12pm",
  "12–2pm",
  "2–4pm",
  "4–6pm",
];

export const fmtTime12 = (t) => {
  const m = /^(\d{1,2}):(\d{2})$/.exec((t || "").trim());
  if (!m) return (t || "").trim();
  let h = parseInt(m[1], 10);
  const ap = h < 12 ? "AM" : "PM";
  h = h % 12 || 12;
  return `${h}:${m[2]} ${ap}`;
};
